const defaultTxData = {
  txLevelX: 0, // 시간 레벨
  txLevelY: 0, // 값 레벨
  txType: 'elapsed', // dataType
  isError: false, // 비정상 트랜잭션만 표시 여부
  stopTaskFlag: false, // Task 정지 여부
  selectedDate: new Date(),
  xStep: 23,
  maxStep: 24,
};

const apm = {
  state: {
    /**
     * apm 트리 타입(키트랜잭션, 어플리케이션, was인스턴스)
     * @type {[type]}
     */
    treeType: null,
    /**
     * 환결설정 apm 트리 데이터(by treetype)
     * @type {Array}
     */
    treeData: [],
    /**
     * 어플리케이션 메뉴의 apm 공통 트리 데이터(by treetype)
     * APM 설정 dom destroy후, 어플리케이션 apm 트리의 데이터를 찾을 수 없으므로 따로 관리.
     * @type {Array}
     */
    commonTreeData: [],
    /**
     * APM 트리에서 선택 되야할 treeKey
     * @type {[type]}
     */
    selectedTreeKey: null,
    /**
     * 탭 유지를 위한 상위 탭 저장
     * @type {[type]}
     */
    mainActiveTab: null,
    /**
     * 탭 유지를 위한 하위 탭 저장
     * @type {[type]}
     */
    subActiveTab: null,
    /**
     * 트랜잭션 분포도 탭 이동시 유지되는 파라메터
     * @type {[type]}
     */
    transactionMatrixData: defaultTxData,
    selectedAnalysisChartDate: null,
  },
  getters: {
    selectedAnalysisChartDate(state) {
      return state.selectedAnalysisChartDate;
    },
  },
  mutations: {
    setTreeType: (state, type) => {
      state.treeType = type;
    },
    setTreeData: (state, treeData) => {
      state.treeData = treeData;
    },
    setCommonTreeData: (state, treeData) => {
      state.commonTreeData = treeData;
    },
    setSelectedTreeKey: (state, treeKey) => {
      state.selectedTreeKey = treeKey;
    },
    setApmMainActiveTab: (state, activeTabName) => {
      state.mainActiveTab = activeTabName;
    },
    setApmSubActiveTab: (state, activeTabName) => {
      state.subActiveTab = activeTabName;
    },
    setTxMatrixData: (state, txData) => {
      state.transactionMatrixData = txData;
    },
    setSelectedAnalysisChartDate: (state, selectedDate) => {
      state.selectedAnalysisChartDate = selectedDate;
    },
  },
  actions: {
    setTreeType({ commit }, type) {
      commit('setTreeType', type);
    },
    setTreeData({ commit }, treeData) {
      commit('setTreeData', treeData);
    },
    setCommonTreeData({ commit }, treeData) {
      commit('setCommonTreeData', treeData);
      commit('setSelectedTreeKey', null);
    },
    setSelectedTreeKey({ commit }, treeKey) {
      commit('setSelectedTreeKey', treeKey);
    },
    setApmMainActiveTab({ commit }, activeTabName) {
      commit('setApmMainActiveTab', activeTabName);
    },
    setApmSubActiveTab({ commit }, activeTabName) {
      commit('setApmSubActiveTab', activeTabName);
    },
    setTxMatrixData({ commit }, txData) {
      commit('setTxMatrixData', txData === null ? defaultTxData : txData);
    },
    setSelectedAnalysisChartDate({ commit }, selectedDate) {
      commit('setSelectedAnalysisChartDate', selectedDate);
    },
  },
};

export default apm;



// WEBPACK FOOTER //
// ./src/store/modules/apm.js